import  {useState, useEffect} from 'react'

export default function useCheckMobileScreen() {
    const [width, setWidth] = useState({"isMobile":window.innerWidth <= 800,"Size": window.innerWidth});
    const handleWindowSizeChange = () => {
            if(!width.isMobile && window.innerWidth <= 800)
                setWidth({"isMobile":window.innerWidth <= 800,"Size": window.innerWidth});
            else if(width.isMobile && window.innerWidth > 800)
                setWidth({"isMobile":window.innerWidth <= 800,"Size": window.innerWidth});
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return (width);
}
